@import '../../utils/focus-ring.css';
@import '../../utils/visually-hidden.css';
@import '../../utils/text-decoration.css';

:host {
  position: relative;
  display: block;
  min-width: 0;
  box-sizing: border-box;
}

.breadcrumb {
  inline-size: 100%;
  min-width: 0;
}

.breadcrumb__list {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  inline-size: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  list-style: none;
}

.breadcrumb__item {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  min-width: 0;
}

.breadcrumb__separator {
  flex: 0 0 auto;
  margin-inline: var(--dimension-space-050);
  user-select: none;
}

.breadcrumb__link,
.breadcrumb__current {
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 0;
  overflow: hidden;
  padding: 0;
  border: 0;
  border-radius: var(--dimension-radius-025);
  background: transparent;
  color: var(--color-foreground-secondary);
  font: inherit;
  text-decoration: none;
}

.breadcrumb__link {
  cursor: default;
}

a.breadcrumb__link {
  cursor: pointer;
}

@media (hover: hover) and (pointer: fine) {
  .breadcrumb__link:hover .breadcrumb__label {
    text-decoration-line: underline;
  }
}

.breadcrumb__label {
  --ds-text-decoration-color: var(--color-foreground-quaternary);

  display: inline-block;
  inline-size: var(--breadcrumb-label-width, auto);
  min-width: 0;
}

.breadcrumb__measurements {
  position: absolute;
  inset: 0 auto auto 0;
  visibility: hidden;
  pointer-events: none;
  white-space: nowrap;
}

.breadcrumb__measurement {
  display: inline-block;
  inline-size: max-content;
  max-inline-size: none;
}
